// tslint:disable: quotemark
import { IProduct } from "./model";
import products_eng from "./data_eng";
import products_ita from "./data_ita";


interface IProductsByLang {
    [index: string]: any[]; // IProduct[];
}
export const products: IProductsByLang = {
    eng: products_eng,
    ita: products_ita,
};
